import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: var(--gradient-dark);
  color: var(--gray-100);
  padding: var(--space-12) var(--space-4) var(--space-8);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: var(--gradient-ice);
    opacity: 0.2;
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-8);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--space-8) var(--space-4);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    text-align: center;
    gap: var(--space-8);
  }
`;

const FooterSection = styled.div`
  h3 {
    color: var(--primary);
    margin-bottom: var(--space-4);
    font-size: 1.2rem;
    position: relative;
    display: inline-block;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 40px;
      height: 2px;
      background: var(--gradient-primary);
      border-radius: var(--radius-full);
      
      @media (max-width: 640px) {
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
`;

const QuickLinks = styled(FooterSection)`
  ul {
    list-style: none;
    padding: 0;
    
    li {
      margin-bottom: var(--space-2);
    }
    
    a {
      color: var(--gray-300);
      font-size: 0.95rem;
      transition: all var(--transition-speed) ease;
      display: inline-block;
      
      &:hover {
        color: var(--primary);
        transform: translateX(5px);
      }
    }
  }
`;

const ContactInfo = styled(FooterSection)`
  ul {
    list-style: none;
    padding: 0;
    
    li {
      color: var(--gray-300);
      font-size: 0.95rem;
      margin-bottom: var(--space-3);
      display: flex;
      align-items: center;
      gap: var(--space-2);
      
      @media (max-width: 640px) {
        justify-content: center;
      }
    }
  }
`;

const SocialLinks = styled(FooterSection)`
  .social-icons {
    display: flex;
    gap: var(--space-4);
    
    @media (max-width: 640px) {
      justify-content: center;
    }
  }
  
  a {
    color: var(--gray-300);
    font-size: 1.5rem;
    transition: all var(--transition-speed) var(--transition-bounce);
    position: relative;
    padding: var(--space-2);
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: var(--gradient-primary);
      opacity: 0;
      border-radius: var(--radius-full);
      transition: opacity var(--transition-speed) ease;
      z-index: -1;
    }
    
    &:hover {
      color: var(--gray-50);
      transform: var(--hover-lift);
      
      &::before {
        opacity: 1;
      }
    }
  }
`;

const BottomBar = styled.div`
  margin-top: var(--space-12);
  padding-top: var(--space-8);
  border-top: 1px solid var(--gray-800);
  text-align: center;
  color: var(--gray-400);
  font-size: 0.9rem;
`;

export { FooterContainer, FooterContent, FooterSection, QuickLinks, ContactInfo, SocialLinks, BottomBar };